<template>
  <v-layout column>
    <v-layout
      v-if="loading == true"
      row
      style="width: 100%"
      pb-2
      justify-end
      align-end
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-layout>
    <v-layout
      v-if="loading == false"
      row
      style="width: 100%"
      pb-2
      justify-end
      align-end
    >
      <v-flex px-2 shrink style="height: 36px">
        <v-checkbox
          v-model="repeatTripDefinition.force"
          v-if="updateMode || alterMode"
          label="Reset & Force Trip Parameters"
        />
      </v-flex>
      <v-flex px-2 shrink style="height: 36px">
        <v-checkbox
          v-model="repeatTripDefinition.recover"
          v-if="updateMode || alterMode"
          label="Recover Cancelled Trips"
        />
      </v-flex>
        <v-btn color="primary" small class="text-capitalize mr-1 ml-1" @click="confirmationEmailDialog = true">Send Confirmation Email</v-btn>
      <v-btn
        v-if="
          (!updateMode || updateMode == null) &&
          (!alterMode || alterMode == null)
        "
        @click="create"
        class="text-none"
        small
        >Create Repeat Trip(s)</v-btn
      >
      <v-btn v-if="updateMode" @click="update" class="text-none" small
        >Update Trip(s)</v-btn
      >
      <v-btn
        v-if="
          repeatService.repeatServiceModel.trip_b == null &&
          repeatService.repeatServiceModel.trip_a.id != null
        "
        @click="addReturnTrip"
        class="text-none"
        small
        >Add Return Trips</v-btn
      >
      <v-flex px-1 shrink>
        <v-btn v-if="alterMode" @click="cancel" class="text-none" small
          >Back</v-btn
        >
      </v-flex>
      <v-flex px-1 shrink>
        <v-btn v-if="alterMode" @click="alter" class="text-none" small
          >Alter Trip(s)</v-btn
        >
      </v-flex>
    </v-layout>
    <p style="color: red; margin-left: 18px">{{ bookingForm.errors.error }}</p>
      <v-dialog
              v-model="confirmationEmailDialog"
              max-width="350"
          >
              <v-card>
                  <v-card-title>Send Confirmation Email</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                      <v-container  class="d-flex justify-center">
                          <v-flex shrink class="mr-2">
                              <v-checkbox
                                  v-model="confirmationEmail.outboundEmail"
                                  :label="`Outbound`"
                              ></v-checkbox>
                          </v-flex>
                          <v-flex>
                              <v-checkbox
                                  v-model="confirmationEmail.returnEmail"
                                  :label="`Return`"
                              ></v-checkbox>
                          </v-flex>
                      </v-container>
                      <v-container>
                          <v-row>
                              <v-col>
                                  <v-text-field label="Email" v-model="confirmationEmail.email"></v-text-field>
                              </v-col>
                          </v-row>
                      </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="text-center text-right" >
                      <v-spacer></v-spacer>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="confirmationEmailDialog = false"
                      >
                          Close
                      </v-btn>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="proceedConfirmationEmail"
                      >
                          Save
                      </v-btn>
                  </v-card-actions>
              </v-card>
          </v-dialog>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "RepeatTripOptions",
  model: {
    prop: "content",
    event: "input",
  },
  components: {
    SimpleTextAreaInput,
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    alterMode: {
      type: Boolean,
      default: false,
    },
    repeatService: Object,
    loading: Boolean,
    repeatTripDefinition: Object,
  },
  data() {
    return {
        confirmationEmail: {
          outboundEmail: true,
          returnEmail: true,
          email: ''
        },
        confirmationEmailDialog: false,
      menu: false,
    };
  },
  methods: {
    proceedConfirmationEmail () {
        this.$store.dispatch('repeatService/sendConfirmationEmail', {repeatServiceId: this.repeatService.repeatServiceModel.id, outboundEmail: this.confirmationEmail.outboundEmail, returnEmail: this.confirmationEmail.returnEmail, email: this.confirmationEmail.email }).then(response => {
            this.confirmationEmailDialog = false
        })
    },
    cancel: function () {
      this.$emit("cancel", null);
    },
    alter: function () {
      this.$emit("alter", null);
    },
    create: function () {
      this.$emit("create", null);
    },
    update: function () {
      this.$emit("update", null);
    },
    addReturnTrip: function () {
      this.$emit("addReturnTrip", null);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
